import React, { Component } from "react";
import { Helmet } from "react-helmet";

export default class ufit extends Component {
  componentDidMount() {
    this._ismounted = true;
    window.slider();
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  render() {
    return (
      <section id="ufit">
        <Helmet>
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Customize workout the way you want.  Create and personalize exercise routines."
          />
          <title>Workout Routines: Customizable Fitness Routines</title>
        </Helmet>
        <a
              href="https://play.google.com/store/apps/details?id=com.doublethefun.ufit"
              target="_blank"
              rel="noopener noreferrer"
            >
        <img
          src="/images/ufit/logo1024.png"
          alt="Workout Routines: Customizable Fitness Routines"
          style={{width:"100%"}}
          //className="center"
        /></a>
        <div className="paragraph col-md-12">
          <h1>Workout Routines: Customizable Fitness Routines</h1>
          Keep fit with personalized exercise routines that you can create and
          customize to your hearts content with the{" "}
          <a
            href="https://play.google.com/store/apps/details?id=com.doublethefun.ufit"
            target="_blank"
            rel="noopener noreferrer"
          >
            Workout Routines: Customizable Fitness Routines
          </a>{" "}
          app. You'll start off with standard exercise legs, abs, and
          chest routines, but then you can customize and set your own schedule
          for the entire week. You can add new routines, set the number of reps
          or duration, record instructional messages, look up videos, and set
          voice counters. You have full control on your workout routine to stay
          fit the way you want.
          <br />
        </div>
        <div className="paragraph col-md-12">
          <h2 className="heading">Features</h2>
          <ul>
            <li>Customizable exercise routines</li>
            <li>Adjust your weekly schedule they way you want</li>
            <li>Share your routines with others</li>
            <li>Download new routines</li>
            <li>Record and customize instructions and counters</li>
            <li>Look up videos for instructions and inspiration</li>
            <li>
              Set up your full body workout or work on your legs, abs, and chest
              separately
            </li>
            <li>Track your progress history and keep fit</li>
          </ul>
        </div>
        <div className="paragraph col-md-12">
          This workout app is suitable for all ages. Be brave, be persistent and
          be fit!
        </div>
      </section>
    );
  }
}
